import { buildGraph, type GraphIssue, validateGraph } from "@velizhanin-dev/bot-scenario"
import { useDeferredValue, useMemo } from "react"
import type { ScenarioDraft } from "@/entities/bot-builder"

export interface GraphIssues {
	issues: GraphIssue[]
	byNode: Map<string, GraphIssue[]>
	errorCount: number
	warningCount: number
}

/**
 * Те же проверки, что блокируют публикацию в api. Проверка всего графа (сотни узлов) тяжёлая,
 * поэтому считается от отложенного черновика: набор текста и клики не ждут её.
 */
export function useGraphIssues(draft: ScenarioDraft | undefined): GraphIssues {
	const deferred = useDeferredValue(draft)
	return useMemo(() => {
		if (!deferred) return { issues: [], byNode: new Map(), errorCount: 0, warningCount: 0 }
		const issues = validateGraph(buildGraph(deferred))
		const byNode = new Map<string, GraphIssue[]>()
		for (const issue of issues) {
			if (!issue.nodeId) continue
			byNode.set(issue.nodeId, [...(byNode.get(issue.nodeId) ?? []), issue])
		}
		const errorCount = issues.filter((issue) => issue.severity === "error").length
		return { issues, byNode, errorCount, warningCount: issues.length - errorCount }
	}, [deferred])
}
